import React from "react";

export function HelpIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill="#656579"
        fillRule="evenodd"
        d="M10 2.292a7.708 7.708 0 1 0 0 15.416 7.708 7.708 0 0 0 0-15.416ZM1.042 10a8.958 8.958 0 1 1 17.916 0 8.958 8.958 0 0 1-17.916 0Z"
        clipRule="evenodd"
      />
      <path
        fill="#656579"
        fillRule="evenodd"
        d="M8.62 6.336c-.286.243-.495.615-.495 1.164a.625.625 0 1 1-1.25 0c0-.91.365-1.632.937-2.117.559-.474 1.281-.696 1.98-.696.698 0 1.42.222 1.98.696.572.485.936 1.208.936 2.117 0 .638-.163 1.125-.43 1.525-.225.337-.516.597-.745.802l-.073.065c-.256.23-.45.42-.59.67-.136.239-.245.573-.245 1.105a.625.625 0 1 1-1.25 0c0-.719.151-1.27.407-1.721.249-.44.577-.745.842-.984l.06-.054c.25-.224.422-.38.554-.576.123-.186.22-.429.22-.832 0-.55-.208-.92-.495-1.164-.3-.255-.724-.399-1.171-.399-.448 0-.87.144-1.171.399Zm1.807 8.198a.626.626 0 0 1 .046.883l-.008.01a.625.625 0 1 1-.93-.837l.009-.01a.625.625 0 0 1 .883-.046Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
